import patientReadingScreen from './patientReadingScreen';

export default {
  patientReading: {
    screen: patientReadingScreen,
  },
};
